







import { CategoryItem } from '@/interfaces/category-item';
import { confirmDelete } from '@/libs/decorator';
import BasePageMixin from '@/mixins/base-page-mixin';
import CategoryServices, { CategoryDto } from '@/services/category';
import DatasourceServices, { DatasourceDto } from '@/services/datasource';
import { mixins } from 'vue-class-component';
import { Vue, Component } from 'vue-property-decorator';
import { Watch } from 'vue-property-decorator';
import { namespace, State } from 'vuex-class';
const System = namespace('System');

@Component({})
export default class DatasourceMenu extends mixins(BasePageMixin) {
  categorySrv = new CategoryServices();
  dsSrv = new DatasourceServices();
  visible: boolean = false;
  categoryType: number = 5;
  folderId: any = 0;

  menu: CategoryItem[] = [
    {
      title: '数据接入',
      icon: 'fa-database',
      type: 'folder',
      oprate: [
        { name: '新建目录', icon: 'fa-folder', key: 'addFolder' },
        { name: '刷新', icon: 'fa-refresh', key: 'refresh' }
      ],
      expand: true,
      children: []
    }
  ];

  async created() {
    this.getCategory();
  }

  // 获取目录
  async getCategory() {
    this.menu[0].loading = true;
    let list = await this.categorySrv.getList({ categoryType_eq: 8 });
    this.menu[0].children = list.map((cate: CategoryDto) => ({
      title: cate.categoryName,
      icon: cate.icon,
      type: 'folder',
      record: cate,
      oprate: [
        { name: '新建数据源', icon: 'fa-plus-circle', permissionKey: 'SUB_ADD', key: 'add' },
        { name: '编辑目录', icon: 'fa-edit', key: 'editFolder' },
        { name: '删除目录', icon: 'fa-trash', key: 'removeFolder' }
      ],
      expand: false,
      id: cate.id,
      children: []
    }));
    this.menu[0].loading = false;
  }

  // 获取目录下文件
  async openFolderById(id: number) {
    let index = this.menu[0].children.findIndex((v: any) => v.id == id);
    this.menu[0].children[+index].loading = true;
    let list = await this.dsSrv.getList({ dsCategoryId_eq: id });
    let plist: object[] = [];
    list.forEach((ds: DatasourceDto) => {
      plist.push({
        title: ds.dsName,
        key: this.getDetailUri(ds),
        icon: 'fa-table',
        id: ds.id,
        record: ds,
        oprate: [
          { name: '编辑', icon: 'fa-edit', permissionKey: 'SUB_UPD', key: 'edit' },
          // { name: '提交审批', icon: 'fa-share', permissionKey: 'SUB_REQ', key: 'approve' },
          { name: '删除', icon: 'fa-trash', permissionKey: 'SUB_DEL', key: 'remove' }
        ]
      });
    });
    this.menu[0].children[+index].children = plist;
    this.menu[0].children[+index].expand = true;
    this.menu[0].children[+index].loading = false;
  }

  getDetailUri = (dto: DatasourceDto) => `/data/datasource/detail?id=${dto.id}`;

  approveVisible: boolean = false;
  approveInfo: any = {};
  command(key: string, record: any) {
    switch (key) {
      case 'add': // 新建
        this.replaceUrl('/data/datasource/add?categoryId=' + record.id);
        break;
      case 'edit': // 编辑
        if (record.approveStatus == 2 || record.approveStatus == 3) {
          this.$message.error('当前状态不能编辑');
          return false;
        }
        this.replaceUrl('/data/datasource/edit?id=' + record.id);
        break;
      case 'remove': // 删除
        if ([1, 2, 3, 7].includes(record.approveStatus)) {
          this.$message.error('当前状态不能删除');
          return false;
        }
        if ([4, 5].includes(record.approveStatus) && record.status == 0) {
          this.$message.error('当前状态不能删除');
          return false;
        }
        this.removeSubject(record.id);
        break;
      case 'approve': // 审批
        if (record.approveStatus > 1) {
          this.$message.error('当前状态不能提交审批');
          return false;
        }
        this.approveInfo = { type: 2, code: record.dsCode, approveStatus: record.approveStatus, uri: this.getDetailUri(record) };
        this.approveVisible = true;
        break;
      case 'addFolder': // 新建目录
        this.folderId = 0;
        this.visible = true;
        break;
      case 'editFolder': // 编辑目录
        this.folderId = record.id;
        this.visible = true;
        break;
      case 'removeFolder': // 删除目录
        this.removeFolder(record.id);
        break;
      case 'expandFolder': // 展开目录
        this.openFolderById(record.id);
        break;
      case 'link':
        // this.$router.push(record);
        this.findAndReplaceUrl(record, '/data/datasource');
        break;
      case 'refresh':
        this.reloadMenu();
      default:
        break;
    }
  }

  async removeFolder(id: number) {
    let res = await this.categorySrv.remove(id);
    if (!res) return false;
    this.$message.success('操作成功');
    this.reloadMenu();
  }

  @confirmDelete()
  async removeSubject(id: number) {
    let res = await this.dsSrv.remove(id);
    if (!res) return false;
    this.$message.success('操作成功');
    this.reloadMenu();
    this.onDeleteRemoveTab('/data/datasource', id);
  }

  @State RELOAD_DS_MENU: any;
  @Watch('RELOAD_DS_MENU')
  reloadMenu() {
    // 重新载入目录下文件
    let openFolderIds: number[] = [];
    this.menu[0].children.forEach((v: any, index: number) => {
      if (v.expand) {
        openFolderIds.push(v.id);
      }
    });
    this.getCategory();
    openFolderIds.forEach(id => this.openFolderById(id));
  }

}
